export default __webpack_public_path__ + "static/antThing_lightbulb-f279da0068e6bda8feacc06070274c6a.png";